import React from 'react';

import livewellFinderLogo from '../../images/livewellfinder-logo.svg';

const Title = () => {
    return (
        <div className="large-wrap justifycentre title-header">
            <img src={livewellFinderLogo} alt="livewell finder logo" />
            <p>Search the community to find activities, groups and meetings to help you reach your goals.</p>
        </div>
    );
}

export default Title;
